import { VideoPreset } from 'livekit-client';

export const MESSENGER_NAME_STORAGE_KEY = 'MESSENGER_NAME';
export const EXTERNAL_NAME_STORAGE_KEY = 'EXTERNAL_NAME';
/** Имя пользователя при bootstrap из messenger web. */
export const MEET_BOOTSTRAP_NAME_STORAGE_KEY = 'MEET_BOOTSTRAP_NAME';
export const APPLICATION_STORAGE_KEY = 'APPLICATION_STORAGE_KEY';
export const LANGUAGE_STORAGE_KEY = 'lang';
export const AVAILABLE_LOCALES = {
    en: 'en',
    ru: 'ru',
} as const;
export const TOKEN_STORAGE_KEY = 'TOKEN';
export const WSSURL_STORAGE_KEY = 'WSS_URL';
export const AUTH_STORE_STORAGE_KEY = 'AUTH_STORE';
export const APP_STORE_STORAGE_KEY = 'APP_STORE';
export const IN_ROOM = 'IN_ROOM';
export const VIRTUAL_BACKGROUNDS = 'VIRTUAL_BACKGROUNDS';

/** sessionStorage/localStorage ключи для VCS (waiting room, bootstrap, настройки). */
export const VCS_WAITING_LIST_ID_STORAGE_KEY = 'VCS_WAITING_LIST_ID_STORAGE_KEY';
/** callId, к которому относится VCS_WAITING_LIST_ID. если не совпадает с VCS_CALL_ID то заявка протухла. */
export const VCS_WAITING_CALL_ID_STORAGE_KEY = 'VCS_WAITING_CALL_ID_STORAGE_KEY';
export const VCS_CALL_ID_STORAGE_KEY = 'VCS_CALL_ID_STORAGE_KEY';
export const VCS_WORKSPACE_ID_STORAGE_KEY = 'VCS_WORKSPACE_ID_STORAGE_KEY';
export const VCS_CALL_INITIATOR_ID_STORAGE_KEY = 'VCS_CALL_INITIATOR_ID';
export const VCS_MEET_BOOTSTRAP_ROOM_KEY = 'VCS_MEET_BOOTSTRAP_ROOM';
/** Комната, для которой сохранён bootstrap из messenger. */
export const VCS_MEET_MESSENGER_BOOTSTRAP_ROOM_KEY = 'VCS_MEET_MESSENGER_BOOTSTRAP_ROOM';
/** JSON: { bootstrap?, prejoinDraft? } политика join на prejoin. */
export const VCS_CALL_POLICY_SESSION_KEY = 'VCS_CALL_POLICY_SESSION';
/** JSON: { microDisabled?, cameraDisabled? } — блокировки вебинара для prejoin после выхода из комнаты. */
export const VCS_WEBINAR_LOCKS_SESSION_KEY = 'VCS_WEBINAR_LOCKS_SESSION';
/**
 * localStorage: данные последнего звонка — переживают F5 (sessionStorage.clear в webEntry).
 * Формат: { roomName, initiatorId?, policy? }
 * При чтении roomName сверяется с текущей комнатой — если не совпадает, данные устарели и чистятся.
 */
export const VCS_CALL_LS_DATA_KEY = 'VCS_CALL_LS_DATA';
export const VCS_PAGE_RELOADING_KEY = 'VCS_PAGE_RELOADING';
/** sessionStorage: F5/reload в waiting room — переживает reload, читается в webEntry до clear. */
export const MEET_PAGE_RELOAD_SESSION_KEY = 'MEET_PAGE_RELOAD_SESSION';
export const VCS_MODERATOR_BYPASS_PREFIX = 'VCS_MODERATOR_BYPASS_';
export const VCS_JOIN_REQUESTS_SOUND_ENABLED_KEY = 'VCS_JOIN_REQUESTS_SOUND_ENABLED';
export const VCS_JOIN_REQUESTS_NOTIFICATIONS_ENABLED_KEY = 'VCS_JOIN_REQUESTS_NOTIFICATIONS_ENABLED';
export const VCS_ACCESS_REQUESTS_SETTINGS_STORE_KEY = 'VCS_ACCESS_REQUESTS_SETTINGS';
export const VCS_DISMISSED_WAITING_IDS_KEY = 'VCS_DISMISSED_WAITING_IDS';
export const VCS_DISMISSED_WAITING_SET_KEY = 'VCS_DISMISSED_WAITING_SET_KEY';

export const BASE_ASPECT_RATIO = 16 / 9;

export enum ERROR_TYPE {
    VCS_P2P_JOIN_BY_LINK_OPERATION_NOT_SUPPORTED = 'VCS_P2P_JOIN_BY_LINK_OPERATION_NOT_SUPPORTED',
    VCS_ROOM_IS_FULL = 'VCS_ROOM_IS_FULL',
    VCS_LOCKED_ROOM_ISNT_STARTED = 'VCS_LOCKED_ROOM_ISNT_STARTED',
}

export enum APPLICATION_KEYS {
    MEET = 'MEET',
}

// \p{Alpha}\p{M}\p{Nd}\p{Pc}\p{Join_C} - all alphabets
// \p{Emoji} - emoji
export const LETTER_REGEXP = `.\\p{Emoji}\\p{Alpha}\\p{M}\\p{Nd}\\p{Pc}\\p{Join_C}\\s()’_-–—!@$%^&*+="№;:?*‘’“”/\\{}\\[\\]|«»`;
export const NAME_REGEXP = new RegExp(`^[${LETTER_REGEXP}]+$`, 'iu');

// Feature flags
export enum FEATURES {
    VCS_SAVE_SETTINGS = 'VCS_SAVE_SETTINGS',
    SIP_ENABLED = 'SIP_ENABLED',
    VCS_CHAT_ENABLED = 'VCS_CHAT_ENABLED',
    VCS_RECORDING_ENABLED = 'VCS_RECORDING_ENABLED',
    VCS_PARTICIPANTS_LIMIT = 'VCS_PARTICIPANTS_LIMIT',
    VCS_MIC_PUSH_ENABLED = 'VCS_MIC_PUSH_ENABLED',
    VCS_MIC_TOGGLE_ENABLED = 'VCS_MIC_TOGGLE_ENABLED',
    VCS_REACTIONS_ENABLED = 'VCS_REACTIONS_ENABLED',
    VCS_VIRTUAL_BACKGROUNDS_ENABLED = 'VCS_VIRTUAL_BACKGROUNDS_ENABLED',
    VCS_MODERATORS_ENABLED = 'VCS_MODERATORS_ENABLED',
    VCS_ACCESS_REQUEST_ENABLED = 'VCS_ACCESS_REQUEST_ENABLED',
    VCS_WEBINAR_ENABLED = 'VCS_WEBINAR_ENABLED',
    VCS_ALONE_IN_CALL_NOTIFICATION_ENABLED = 'VCS_ALONE_IN_CALL_NOTIFICATION_ENABLED',
    VCS_AI_RECAP_ENABLED = 'VCS_AI_RECAP_ENABLED', // для включения/выключения всего функционала AI Recap
    LOCAL_VCS_AI_RECAP_ENABLED = 'LOCAL_VCS_AI_RECAP_ENABLED', // локальны ФФ для включения/выключения функционала AI Recap с дополнительными условиями
    LOCAL_VCS_WAITING_LOTTIE_LAYOUT_ENABLED = 'LOCAL_VCS_WAITING_LOTTIE_LAYOUT_ENABLED', // REACT_APP_VCS_WAITING_LOTTIE_LAYOUT_ENABLED в .env-cmdrc
    /** Отдельная секция поднятых рук (+ скрытие иконки в общем списке). Для IS_T / Tango выключен. */
    LOCAL_VCS_RAISED_HANDS_LIST_ENABLED = 'LOCAL_VCS_RAISED_HANDS_LIST_ENABLED',
    VCS_MUTED_SPEECH_DETECTION_ENABLED = 'VCS_MUTED_SPEECH_DETECTION_ENABLED',
    VCS_ADVANCED_SOUND_CAMERA_SETTINGS_ENABLED = 'VCS_ADVANCED_SOUND_CAMERA_SETTINGS_ENABLED',
    VCS_SPEAKER_ANIMATIONS_ENABLED = 'VCS_SPEAKER_ANIMATIONS_ENABLED',
}

/**
 * Пресеты качества видео для ВКС
 * Правила качества на одного участника:
 *
 * HIGH (≤4 участника):
 *   - frameheight: ≤720px
 *   - bitrate: ≤1,200,000 bps
 *   - framesDecoded: ≤24 fps
 *
 * MEDIUM (5-9 участников):
 *   - frameheight: ≤360px
 *   - bitrate: ≤350,000 bps
 *   - framesDecoded: ≤20 fps
 *
 * LOW (≥10 участников):
 *   - frameheight: ≤180px
 *   - bitrate: ≤120,000 bps
 *   - framesDecoded: ≤15 fps
 */

// Единый источник истины для лимитов качества видео
export const VIDEO_QUALITY_LIMITS = {
    HIGH: { maxBitrate: 1_200_000, maxFramerate: 24, maxWidth: 1280, maxHeight: 720 },
    MEDIUM: { maxBitrate: 350_000, maxFramerate: 20, maxWidth: 640, maxHeight: 360 },
    LOW: { maxBitrate: 120_000, maxFramerate: 15, maxWidth: 320, maxHeight: 180 },
} as const;

/**
 * Лимиты битрейта для screen share
 * Screen share требует больше битрейта чем камера для качественной передачи,
 * но ограничиваем для контроля общего трафика
 */
export const SCREEN_SHARE_BITRATE_LIMITS = {
    HIGH: 3_000_000, // 3 Мбит/с для 1080p
    MEDIUM: 2_000_000, // 2 Мбит/с для 720p
    LOW: 1_000_000, // 1 Мбит/с для 360p
} as const;

export const VIDEO_PRESETS = {
    LOW: new VideoPreset(
        VIDEO_QUALITY_LIMITS.LOW.maxWidth,
        VIDEO_QUALITY_LIMITS.LOW.maxHeight,
        VIDEO_QUALITY_LIMITS.LOW.maxBitrate,
        VIDEO_QUALITY_LIMITS.LOW.maxFramerate,
    ),
    MEDIUM: new VideoPreset(
        VIDEO_QUALITY_LIMITS.MEDIUM.maxWidth,
        VIDEO_QUALITY_LIMITS.MEDIUM.maxHeight,
        VIDEO_QUALITY_LIMITS.MEDIUM.maxBitrate,
        VIDEO_QUALITY_LIMITS.MEDIUM.maxFramerate,
    ),
    HIGH: new VideoPreset(
        VIDEO_QUALITY_LIMITS.HIGH.maxWidth,
        VIDEO_QUALITY_LIMITS.HIGH.maxHeight,
        VIDEO_QUALITY_LIMITS.HIGH.maxBitrate,
        VIDEO_QUALITY_LIMITS.HIGH.maxFramerate,
    ),
};

/** Стандартные WebRTC audio constraints **/
export const AUDIO_CONSTRAINTS: MediaTrackConstraints = {
    // Убирает «эхо», когда звук от удалённых участников попадает в твой mic и возвращается к ним обратно.
    echoCancellation: true,
    // Фильтрует стационарный фоновый шум — гул кулера, вентиляции, кондиционера, лёгкий гул улицы за окном.
    noiseSuppression: true,
    // Динамически подстраивает уровень захвата. Если ты говоришь тихо — алгоритм пампит сигнал вверх; если громко — поджимает.
    autoGainControl: true,
};

/**
 * Режимы отображения комнаты (stage layout)
 */
export const STAGE_LAYOUT = {
    GRID: 'grid',
    SPEAKER: 'speaker',
} as const;

export type StageLayout = (typeof STAGE_LAYOUT)[keyof typeof STAGE_LAYOUT];

/**
 * Режимы комнаты для управления качеством видео
 */
export const ROOM_MODE = {
    GRID: 'grid',
    SPEAKER: 'speaker',
    SCREEN_SHARE: 'screenShare',
} as const;

export type RoomMode = (typeof ROOM_MODE)[keyof typeof ROOM_MODE];

/**
 * Порог для оптимизации больших комнат
 * При превышении этого количества участников применяются специальные оптимизации:
 * - Подписки только на видимые видео (через IntersectionObserver)
 * - Качество видео всегда LOW
 * - Ограничение количества видимых участников
 */
export const LARGE_ROOM_PARTICIPANTS_THRESHOLD = 25;

/**
 * Пороги количества участников для определения качества видео в Grid режиме
 */
export const VIDEO_QUALITY_THRESHOLDS = {
    HIGH_MAX_PARTICIPANTS: 4,
    MEDIUM_MAX_PARTICIPANTS: 9,
} as const;

/**
 * Конфигурация для IntersectionObserver при отслеживании видимости участников
 */
export const INTERSECTION_OBSERVER_CONFIG = {
    root: null,
    rootMargin: '0px',
    defaultThreshold: 0.6,
} as const;

export const MESSAGE_FIELD_ID = 'MESSAGE_FIELD';

export const MOBILE_STAGE_VIEW_WIDTH = 991;

export { VCS_JOIN_POLICY, type VcsJoinPolicy, normalizeJoinPolicy } from '@web-chat-core/toolkit';
